<template>
  <div>
    <a-button style="margin-left: 8px;color:#000;" @click="()=>{show=!show}">
      <a-icon type="filter" />
    </a-button>
    <div v-if="show" class="cf-check">
      <div :style="{ borderBottom: '1px solid #E9E9E9' }">
        <a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange">全选</a-checkbox>
        <a-checkbox :checked="checkedDefault" @change="newColumns">默认</a-checkbox>
      </div>
      <a-checkbox-group v-model="checkedOps" @change="onChange">
        <a-row v-bind:key="op.label" v-for="op in options">
          <a-col :span="24">
            <a-checkbox :value="op.value" :checked="checkedOps.contains(op.value)">{{ op.label }}</a-checkbox>
          </a-col>
        </a-row>
      </a-checkbox-group>
    </div>
  </div>
</template>
<script>
export default {
  name: "columns-filter",
  props: ["columns", "oldColumns"],
  data() {
    return {
      options: [],
      checkedOps: [],
      show: false,
      ss: null,
      hash: null,
      username: null,
      indeterminate: true,
      checkAll: false,
      checkedDefault: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  created() {
    this.hash = location.hash.replace("#/", "");
    this.username = this.user.username;
    let ls = localStorage.getItem("column-" + this.username + "-" + this.hash);
    if (ls != "{}") {
      this.ss = JSON.parse(ls);
    }
    if (this.ss) {
      console.info("使用用户缓存配置！");
      this.oldColumns.forEach((column, index) => {
        this.options.push({ label: column.title, value: index });
        if (this.ss[column.title]) {
          this.checkedOps.push(index);
        }
      });
    } else {
      this.oldColumns.forEach((column, index) => {
        this.options.push({ label: column.title, value: index });
        if (!column.hidden) {
          this.checkedOps.push(index);
        }
      });
    }
    this.newColumns();
  },
  methods: {
    onChange(checkedList) {
      this.checkedOps = checkedList;
      this.newColumns();
    },
    newColumns(e) {
      this.ss = {};
      let newColumns = [];
      if (e && e.target.checked) {
        this.checkedOps = [];
        this.checkedDefault = true;
        this.oldColumns.forEach((column, index) => {
          if (!column.hidden) {
            this.checkedOps.push(index);
          }
        });
      } else {
        this.checkedDefault = false;
      }
      this.indeterminate =
        !!this.checkedOps.length &&
        this.checkedOps.length < this.options.length;
      this.checkAll = this.checkedOps.length === this.options.length;

      this.oldColumns.forEach((column, index) => {
        if (this.checkedOps.contains(index)) {
          newColumns.push(column);
          this.ss[column.title] = true;
        }
      });

      this.$emit("update:columns", newColumns);

      if (this.ss != {}) {
        localStorage.setItem(
          "column-" + this.username + "-" + this.hash,
          JSON.stringify(this.ss)
        );
      }
    },
    onCheckAllChange(e) {
      let allOp = [];
      this.options.forEach((op, index) => {
        allOp.push(op.value);
      });
      if (e.target.checked) {
        this.checkedOps = allOp;
      } else {
        this.checkedOps = [];
      }
      this.newColumns();
    },
  },
};
</script>
<style scoped>
.cf-check {
  position: fixed;
  height: 70%;
  overflow: auto;
  right: 3%;
  background-color: #fff;
  border: 1px #e8e8e8 solid;
  padding: 10px;
  border-radius: 5px;
  z-index: 99;
}
</style>